import React from "react";

export function MemberBadge({ isPaidMember }) {
  if (!isPaidMember) {
    return <span className="badge badge--grey">Free</span>
  }

  return <span className="badge" role="img" aria-label="Cerified member">Member ❤️</span>
}